import { useI18n, type Lang } from '../lib/i18n'

const CICLO = ['pt', 'es', 'en'] as const satisfies readonly Lang[]

/**
 * Botão de ciclo PT → ES → EN → PT, mesmo padrão visual/interação já usado
 * em Filtro, Squelch, Modo (CW) e Zoom do waterfall — um toque avança para o
 * próximo estado, sem abrir menu nenhum.
 */
export function LangSelector() {
  const { lang, t, setLang } = useI18n()

  const proximo = () => {
    const i = CICLO.indexOf(lang)
    setLang(CICLO[(i + 1) % CICLO.length] ?? CICLO[0])
  }

  return (
    <button
      type="button"
      className="pill lang-selector"
      onClick={proximo}
      aria-label={`${t.langSelector.idioma}: ${lang.toUpperCase()}`}
    >
      {lang.toUpperCase()}
    </button>
  )
}
